import React, { useEffect, useState } from "react";
import TrendingSvg from "../../images/icons/trending.svg";
import "./explore.css";
import { Link } from "react-router-dom";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { carouselbreakPoints } from "../../constants/constant";
import { fetch_all_events } from "../../actions/events/event";
import { baseURL } from "../../constants/Api";

const EventList = (props) => {
   
  const {eventList} = props;
  

  return (
    <div className="explore-section mb-3">
     {eventList.length ? <div>
      <div className="flex items-center mt-3 heading-part gap-3 mb-3">
        <img src={TrendingSvg} alt="" />
        Trending Events
      </div>
       
      <Carousel
       responsive={carouselbreakPoints}
      >
        {eventList.map((item, i) => {
          return (
            <a
              key={i}
              href={`${baseURL}/event-details/${item?.id}/${item?.slug}`}
              state={item}
              className="flex flex-col w-11/12"
            >
              {console.log(item)}
              <div
                className="hotel-img sm:h-40 h-28 w-full object-cover"
                style={{
                  background: item.image  ? `url(${item.image})` : "gray",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              ></div>
              <div className="name mt-2 capitalize">{item?.name}</div>
              <div className="place">{item?.hotelName}</div>
            </a>
          );
        })}
        </Carousel>
        </div>:null}
    </div>
  );
};

export default EventList;
